import React, { Component } from "react";
import { generateValidBookLevelValues, getValidInterestLevels } from "lib/acceleratedReader/AcceleratedReaderInputUtilities";
import PropTypes from "prop-types";
import Dropdown from "react/views/generic/Dropdown";
import "./acceleratedReaderInputs.less";

class AcceleratedReaderInputs extends Component {
	constructor(props) {
		super(props);
		
		this.validBookLevels = generateValidBookLevelValues();
		this.validInterestLevels = getValidInterestLevels();
		
	}

	render() {
		
		//Need an obj of val and display prop as we want the value on <options/> to be different that the display text.
		let bookLevelInputs = this.validBookLevels.map(item => {
			return { val: item, displayText: item };
		});
		return (
			<div className="accelerated-reader-search">
				<Dropdown className="book-level-dropdown" selected={this.props.bookLevel} items={bookLevelInputs} handleChange={this.props.handleBookLevelChange}  />
				<Dropdown className="interest-level-dropdown" selected={this.props.interestLevel} items={this.validInterestLevels} handleChange={this.props.handleInterestLevelChange}/>
			</div>
		);
	}
}

AcceleratedReaderInputs.propTypes = {
	bookLevel: PropTypes.string,
	interestLevel: PropTypes.string,
	handleBookLevelChange:PropTypes.func.isRequired,
	handleInterestLevelChange: PropTypes.func.isRequired
};
export default AcceleratedReaderInputs;



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/acceleratedReader/AcceleratedReaderInputs.jsx